import cartPage from './views/cartPage';
import checkoutPage from './views/checkoutPage';
import detailPage from './views/detailPage';
import landingPage from './views/landingPage';
import yourOrderPage from './views/yourOrderPage';
import yourAccountPage from './views/yourAccountPage';

export const clickEvents = {
  cartPage: cartPage.clickEvents,
  detailPage: detailPage.clickEvents,
  checkoutPage: checkoutPage.clickEvents,
  landingPage: landingPage.clickEvents,
  yourOrderPage: yourOrderPage.clickEvents,
  yourAccountPage: yourAccountPage.clickEvents
};

export const loadingEvents = {
  cartPage: cartPage.loadingEvents,
  detailPage: detailPage.loadingEvents,
  checkoutPage: checkoutPage.loadingEvents,
  landingPage: landingPage.loadingEvents,
  yourOrderPage: yourOrderPage.loadingEvents,
  yourAccountPage: yourAccountPage.loadingEvents
};

export const businessEvent = {
  cartPage: cartPage.businessEvent
};
